// extracted by mini-css-extract-plugin
export default {"container":"TargetAuditionLabel_container__gysXl"};